export default {
  sort: 5,
  path: '/details/:id',
  name: 'Details',
  component: () => import('@/views/Details'),
}


// WEBPACK FOOTER //
// ./src/router/modules/details.js